<template>
  <v-container fluid class="mx-1" v-if="languageData.labels">
    <!-- Snackbar do wyświetlania komunikatów -->
    <v-snackbar
        v-model="snackbar.visible"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        :top="snackbar.position === 'top'"
    >
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <v-btn icon @click="snackbar.visible = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null">
      <v-row justify="center">
        <v-col cols="12">
          <v-stepper v-model="e1" class="transparent elevation-0">
            <v-card class="mb-5">
              <v-stepper-header class="autoheight">
                <div class="py-5 pl-5 mr-3">
                  <BackButton />
                </div>
                <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>
                <v-stepper-step :complete="e1 > 1" step="1">{{ languageData.header.profileEdit }}</v-stepper-step>
                <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>
              </v-stepper-header>
            </v-card>
            <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null">
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card>
                    <v-form ref="profileForm" v-model="valid" @submit.prevent="updateProfile">
                      <p class="text-h5 mb-7">{{ languageData.header.profileEdit }}</p>
                      <v-row>
                        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                          <v-text-field
                              :label="languageData.labels.email"
                              v-model="form.email"
                              outlined
                              type="email"
                              :error-messages="errors.email"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                          <v-text-field
                              :label="languageData.labels.name"
                              v-model="form.firstname"
                              outlined
                              :error-messages="errors.firstname"
                          ></v-text-field>
                        </v-col>
                        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                          <v-text-field
                              :label="languageData.labels.surname"
                              v-model="form.lastname"
                              outlined
                              :error-messages="errors.lastname"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                          <v-text-field
                              :label="languageData.labels.password"
                              v-model="form.password"
                              outlined
                              type="password"
                              :error-messages="errors.password"
                          ></v-text-field>
                        </v-col>
                        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                          <v-text-field
                              :label="languageData.labels.passwordRepeat"
                              v-model="form.password_confirmation"
                              outlined
                              type="password"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-btn type="submit" color="primary">{{ languageData.button.save }}</v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-card>
          </v-stepper>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import BackButton from "../../../components/Global/BackButton.vue";

export default {
  components: {
    BackButton,
  },
  data() {
    return {
      form: {
        email: '',
        firstname: '',
        lastname: '',
        password: '',
        password_confirmation: ''
      },
      errors: {},
      message: '',
      valid: true,
      e1: 1,
      snackbar: {
        visible: false,
        color: '',
        timeout: 6000,
        position: 'top',
        icon: '',
        text: ''
      },
    };
  },
  computed: {
    ...mapGetters('getUser', ['currentUser']),
  },
  mounted() {
    this.loadUser();
  },
  methods: {
    ...mapActions('getUser', ['fetchUser']),
    async loadUser() {
      try {
        await this.fetchUser();
        this.setFormData();
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    },
    setFormData() {
      if (this.currentUser) {
        console.log('Setting form data with currentUser:', this.currentUser);
        this.form.email = this.currentUser.email || '';
        this.form.firstname = this.currentUser.firstname || '';
        this.form.lastname = this.currentUser.lastname || '';
      }
    },
    async updateProfile() {
      try {
        const formData = {
          ...this.form,
        };

        const result = await sendRequest("put", config.baseURLApi + "/users/profile", {}, formData);
        if (result[0] === "success") {
          this.$store.commit('getUser/GET_USER_SUCCESS', result[1]);
          this.message = result[1].message || 'Das Profil wurde erfolgreich aktualisiert';
          this.errors = {};

          this.snackbar.visible = true;
          this.snackbar.color = 'success';
          this.snackbar.icon = 'mdi-check-circle';
          this.snackbar.text = 'Das Profil wurde erfolgreich aktualisiert';
        } else {
          this.errors = result[1].errors;

          this.snackbar.visible = true;
          this.snackbar.color = 'error';
          this.snackbar.icon = 'mdi-alert-circle';
          this.snackbar.text = 'Beim Aktualisieren des Profils ist ein Fehler aufgetreten';
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors;
        } else {
          console.error(error);
          this.snackbar.visible = true;
          this.snackbar.color = 'error';
          this.snackbar.icon = 'mdi-alert-circle';
          this.snackbar.text = 'Ein unerwarteter Fehler ist aufgetreten';
        }
      }
    }
  }
};
</script>
